import { CruiseWizardState, VrWizardState, LxWizardState } from "src/stores/wizard/state";

import { mapFlightWizardState } from "./FlightWizardStateMapper";
import { mapLegacyHotelWizardState } from "./LegacyHotelWizardStateMapper";
import { mapPackageWizardState } from "./PackageWizardStateMapper";
import { mapCarWizardState } from "./CarWizardStateMapper";
import { IntentMediaWizardMapping } from "../typings";

function mapCruiseWizardState(state: CruiseWizardState) {
  return undefined; // needs implementation
}

function mapVrWizardState(state: VrWizardState) {
  return undefined; // needs implementation
}

function mapLxWizardState(state: LxWizardState) {
  return undefined; // needs implementation
}

export function mapFlightTripType(tripType: string) {
  return tripType === "ONE_WAY" ? "ONEWAY" : "ROUNDTRIP";
}

export function mapTravelDate(tripDate: Date) {
  const parsedDate = new Date(tripDate);
  const year = parsedDate.getUTCFullYear();
  const month = (parsedDate.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = parsedDate
    .getUTCDate()
    .toString()
    .padStart(2, "0");

  return `${year}${month}${day}`;
}

export function mapWizardState(state: IntentMediaWizardMapping | undefined) {
  if (state) {
    return mapWizardStateLob(state, state.lob || "");
  }

  return undefined;
}

export function mapWizardStateLob(state: IntentMediaWizardMapping | undefined, lob: string) {
  let intentMediaProperties: any;

  if (state) {
    // flights
    if ("wizard-flight-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapFlightWizardState(state.wizardState.flightWizardState);
    }

    // hotels
    else if ("wizard-hotel-pwa" === lob && state.legacyWizardState) {
      intentMediaProperties = mapLegacyHotelWizardState(state.legacyWizardState);
    }

    // cruise
    else if ("wizard-cruise-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapCruiseWizardState(state.wizardState.cruiseWizardState);
    }

    // car
    else if ("wizard-car-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapCarWizardState(state.wizardState.carWizardState);
    }

    // vr
    else if ("wizard-vr-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapVrWizardState(state.wizardState.vrWizardState);
    }

    // lx
    else if ("wizard-lx-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapLxWizardState(state.wizardState.lxWizardState);
    }

    // packages
    else if ("wizard-package-pwa" === lob && state.wizardState) {
      intentMediaProperties = mapPackageWizardState(state.wizardState.packageWizardState);
    }
  }

  return intentMediaProperties;
}

export function pageIdMapper(lob: string) {
  switch (lob) {
    case "wizard-flight-pwa":
      return "homepage.flights";
    case "wizard-car-pwa":
      return "homepage.cars";
    case "wizard-hotel-pwa":
      return "homepage.hotels";
    case "wizard-package-pwa":
      return "homepage.packages";
    default:
      return "homepage";
  }
}
